import { type SortDirection } from 'types/enums'

export enum AnalyticsContentModalSortBy {
    overall_revenue = 'overall_revenue',
    purchases = 'purchases',
    purchase_quantity = 'purchase_quantity',
    tips = 'tips',
    tip_quantity = 'tip_quantity',
    media_views = 'media_views',
    date_published = 'date_published',
    impressions = 'impressions',
    average_video_played = 'average_video_played',
    videoCompletionRate = 'average_video_played',
    purchaseRate = 'purchase_rate',
    media_views_impression_rate = 'media_views_impression_rate',
    purchase_impression_rate = 'purchase_impression_rate',
    engagement_rate = 'engagement_rate',
    likes = 'likes',
    comments = 'comments'
}

export interface ContentModalSortFilter {
    sort_by: AnalyticsContentModalSortBy | ''
    sort_value: SortDirection | ''
}
